import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import { styled, alpha } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Slider_lenta from "../../elements/slider/slider";
import api from "../../api";
// import "./Lenta_card.css";
import Content from "./content";
import RepostFunc from "../../elements/repost/repost";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import * as React from "react";
import { setComentShow } from "../../store/comentSelector";
import ComentDialogs from "../../elements/coment/coment";

import { grey } from "@mui/material/colors";

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
  marginTop: 2,
  marginLeft: 1,
  marginRight: 1,
  marginBottom: 2,
  textAlign: "center",
  backgroundColor: alpha(theme.color.main, 1),
}));

const Lenta_text = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0),
  margin: 0,
  textAlign: "center",
  color: grey[400],
  fontSize: "0.8rem",
  fontFamily: "Roboto",
  // border: "1px",
}));

export default function LentaCardApp({ e }) {
  const [like, setLike] = useState(getCookie() ? getCookie() : []);
  const [countLike, setCountLike] = useState(e.like);
  const [countComent, setCountComent] = useState(e.coments.length);
  const [nowComent, setnowComent] = useState("");
  const [nowId, setnowId] = useState();
  const comentShow = useSelector((state) => state.comentSelector.coment);
  // const [open_win, setOpen_win] = useState(false);
  const dispatch = useDispatch();
  const changeLike = (name) => {
    if (like.includes(name)) {
      setLike(like.filter((task) => task !== name));
      setCountLike(countLike - 1);
    } else {
      setLike((current) => [...current, name]);
      setCountLike(countLike + 1);
    }
  };

  const sendCountLike = () => {
    api.sendLike(countLike, e.id);
  };

  // const comentShowFunc = (e) => {
  //   dispatch(setComentShow(e));
  //   console.log(e);
  //   // api.sendLike(countLike, e.id);
  // };

  const comentShowFunc = (e) => {
    api
      .getNew(e.id)
      .then((response) => {
        dispatch(setComentShow(response.data));
        console.error(response.data);
      })
      .catch((error) => {
        // Если запрос не будет выполнен, то ошибка выводится в терминал
        console.error(error);
      });
  };

  const editCookie = (like) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 150);
    const expires = expirationDate.toUTCString();
    document.cookie = "fprz" + "=" + like + ";" + expires + ";path=/";
  };

  function getCookie() {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, 5) === "fprz=") {
          cookieValue = decodeURIComponent(cookie.substring(5));
          cookieValue = cookieValue.split(",");
          break;
        }
      }
    }
    return cookieValue;
  }
  // const showComent = (id, coments) => {
  //   dispatch(setComentShow());
  //   setnowComent(coments);
  //   setnowId(id);
  //   console.log("Лента Кард!!!!!!!!");
  //   console.log(nowComent);
  //   console.log(nowId);
  // };

  useEffect(() => {
    console.log("Лента Кард!!!!!!!!");
    // console.log(e.newimages[0]);
    sendCountLike(countLike);
    editCookie(like);
  }, [like, countLike]);
  return (
    <div>
      {comentShow && <ComentDialogs />}
      <Item elevation={12}>
        <Typography variant="h6" gutterBottom>
          {e.title}
        </Typography>
        <Slider_lenta data={e.newimages} />
        <Box sx={{ m: { xs: 2, sm: 3, lg: 3 } }}>
          <Content e={e.content} id={e.id} />
        </Box>
        <Stack direction="row" spacing={0} justifyContent="space-around">
          <Stack direction="row" spacing={0} justifyContent="space-around">
            <div
              onClick={() => changeLike(e.time_create)}
              className="zoom-effect"
            >
              {like.includes(e.time_create) ? (
                <IconButton aria-label="нравится">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 512 512"
                    fill={grey[400]}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m126.06 177.71h-43.06v55a15 15 0 0 1 -30 0v-55h-38a15 15 0 0 0 -15 15v280a15 15 0 0 0 15 15h111.06z" />
                    <path d="m407 409.85a15 15 0 0 1 0-30h105v-70h-105a15 15 0 0 1 0-30h105v-47.14a55.06 55.06 0 0 0 -55-55h-41.58v25a15 15 0 0 1 -30 0v-127.71a75.09 75.09 0 0 0 -75-75h-6a35 35 0 0 0 -35 35v97.71a45.05 45.05 0 0 1 -45 45h-68.36v317.2l32.32 13.09a54.87 54.87 0 0 0 20.62 4h248a55.06 55.06 0 0 0 55-55v-47.15z" />
                  </svg>
                </IconButton>
              ) : (
                <IconButton aria-label="нравится">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={grey[400]}
                  >
                    <path d="m457 177.71h-71.59v-102.71a75.09 75.09 0 0 0 -75-75h-6a35 35 0 0 0 -35 35v97.71a45.05 45.05 0 0 1 -45 45h-209.41a15 15 0 0 0 -15 15v280a15 15 0 0 0 15 15h123.14l50.24 20.29a54.87 54.87 0 0 0 20.62 4h248a55.06 55.06 0 0 0 55-55v-224.29a55.06 55.06 0 0 0 -55-55zm-427 30h33v25a15 15 0 0 0 30 0v-25h33v250h-96zm427 274.29h-248a24.67 24.67 0 0 1 -9.37-1.83l-43.58-17.63v-254.83h68.35a75.09 75.09 0 0 0 75-75v-97.71a5 5 0 0 1 5-5h6a45 45 0 0 1 45 45v157.71a15 15 0 0 0 30 0v-25h71.6a25 25 0 0 1 25 25v47.14h-75a15 15 0 0 0 0 30h75v70h-75a15 15 0 0 0 0 30h75v47.15a25 25 0 0 1 -25 25z" />
                  </svg>
                </IconButton>
              )}
            </div>
            <div className="zoom-effect">
              <Lenta_text>{countLike}</Lenta_text>
            </div>
          </Stack>
          <Stack direction="row" spacing={0} justifyContent="space-around">
            <div className="zoom-effect">
              <IconButton aria-label="просмотры">
                <svg
                  width="25"
                  height="25"
                  id="Layer_2"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="Layer 2"
                  fill={grey[400]}
                >
                  <path d="m30.787 15.383c-.268-.342-6.661-8.383-14.787-8.383s-14.519 8.041-14.787 8.383a1 1 0 0 0 0 1.234c.268.342 6.661 8.383 14.787 8.383s14.519-8.041 14.787-8.383a1 1 0 0 0 0-1.234zm-14.787 5.617a5 5 0 1 1 5-5 5.006 5.006 0 0 1 -5 5z" />
                </svg>
              </IconButton>
            </div>
            <div className="zoom-effect">
              <Lenta_text>{e.count_view}</Lenta_text>
            </div>
          </Stack>

          <Stack direction="row" spacing={0} justifyContent="space-around">
            <div onClick={() => comentShowFunc(e)} className="zoom-effect">
              <IconButton aria-label="коментарии">
                <svg
                  width="30"
                  height="30"
                  viewBox="-3 -4 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3H5C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H8L11.6464 20.6464C11.8417 20.8417 12.1583 20.8417 12.3536 20.6464L16 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3Z"
                    stroke={grey[400]}
                  />
                </svg>
              </IconButton>
            </div>
            <div className="zoom-effect">
              <Lenta_text>{countComent}</Lenta_text>
            </div>
          </Stack>
          <RepostFunc data={e} />

          <div className="zoom-effect">
            <Lenta_text>{e.time_create}</Lenta_text>
          </div>
        </Stack>
      </Item>
    </div>
  );
}
